/* ============================================================
   HimalayaEcho · Cart Drawer "Complete the look"（S4-4 AOV · 2026-06-13）
   抽屉首件 → Shopify 关联推荐 3 件 +Add；随抽屉重渲染自动补位。
   ============================================================ */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  ROOT = ROOT.replace(/\/$/, '');

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function render(box) {
    if (box.dataset.heUpsellDone === '1') return;
    box.dataset.heUpsellDone = '1';
    var row = box.querySelector('[data-he-upsell-row]');
    var seed = box.getAttribute('data-seed');
    var inCart = (box.getAttribute('data-incart') || '').split(',').filter(Boolean);
    if (!row || !seed) { box.hidden = true; return; }

    fetch(ROOT + '/recommendations/products.json?product_id=' + seed + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var picks = (data.products || []).filter(function (p) {
          return inCart.indexOf(String(p.id)) === -1 && p.available !== false;
        }).slice(0, 3);
        if (!picks.length) { box.hidden = true; return; }
        row.innerHTML = picks.map(function (p) {
          var img = (p.featured_image || (p.images && p.images[0]) || '');
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          var v = (p.variants && p.variants[0]) || {};
          var price = (typeof p.price === 'number') ? p.price : (v.price || 0);
          return (
            '<div class="he-cart-upsell__item">' +
              '<a class="he-cart-upsell__media" href="' + ROOT + '/products/' + p.handle + '">' +
                (img ? '<img src="' + img + '&width=160" alt="" loading="lazy" width="80" height="80">' : '') +
              '</a>' +
              '<div class="he-cart-upsell__info">' +
                '<a class="he-cart-upsell__name" href="' + ROOT + '/products/' + p.handle + '">' + p.title + '</a>' +
                '<span class="he-cart-upsell__price">' + money(price) + '</span>' +
              '</div>' +
              '<button type="button" class="he-cart-upsell__add" data-vid="' + v.id + '" aria-label="Add ' + p.title + '">+ Add</button>' +
            '</div>'
          );
        }).join('');
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; });
  }

  function add(btn) {
    var vid = btn.getAttribute('data-vid');
    if (!vid) return;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch(ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data.sections['cart-drawer'];
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) { drawer.innerHTML = fresh.innerHTML; }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections['cart-icon-bubble']) {
          var t2 = document.createElement('div'); t2.innerHTML = data.sections['cart-icon-bubble'];
          var fb = t2.querySelector('#cart-icon-bubble') || t2.firstElementChild;
          if (fb) bubble.innerHTML = fb.innerHTML;
        }
        scan();
      } else {
        btn.disabled = false; btn.textContent = label;
      }
    }).catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  function scan() {
    document.querySelectorAll('[data-he-cart-upsell]').forEach(render);
  }

  document.addEventListener('click', function (e) {
    var add_btn = e.target.closest('.he-cart-upsell__add');
    if (add_btn) { e.preventDefault(); add(add_btn); }
  });

  /* 抽屉由 Dawn cart.js 整段重渲染 → 监听 DOM 变化补位 */
  var mo = new MutationObserver(function () { scan(); });
  function init() {
    scan();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
